
import { useState } from "react";
import { FQAData } from "../data/profile/faq";
import { BiChevronDown, BiChevronUp } from "react-icons/bi";
import { MdKeyboardBackspace } from "react-icons/md";
import { useNavigate } from "react-router-dom";
export default function FAQPage() {
  const [activeIndex, setActiveIndex] = useState(null);
  const navigate=useNavigate();
  const toggleFAQ = (index) => {
    setActiveIndex(prev => (prev === index ? null : index));
  };

  return (
    <div className="py-5 px-4 md:px-8 xl:px-10">
        <div className="flex flex-row space-x-2 items-center justify-start mb-5" onClick={()=>navigate(-1)}>
            <MdKeyboardBackspace className="text-lg md:text-xl xl:text-2xl" />
            <p className="text-lg md:text-xl xl:text-2xl font-medium text-center pb-2">Frequently Asked Questions</p>
        </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8">
        {FQAData.map((faq, index) => (
          <div key={index} className="border border-gray-300 rounded-lg shadow-md text-xs md:text-sm xl:text-base">
            <button
              onClick={() => toggleFAQ(index)}
              className="flex justify-between items-center w-full px-4 py-3 text-left font-medium text-gray-800 hover:bg-gray-100 transition"
            >
              <span>{faq.question}</span>
              {activeIndex === index ? (
                <BiChevronUp className="w-5 h-5" />
              ) : (
                <BiChevronDown className="w-5 h-5" />
              )}
            </button>
            {activeIndex === index && (
              <div className="px-4 py-3 text-gray-600 border-t border-gray-200 bg-gray-50">
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
